import { MediaModel } from "../models/MediaModel";
import { DomUtils } from "socios-tools/utils/DomUtils";
export class TopicManager {
    constructor() {
        this._currentTopicID = '';
        this.checkTopic = () => {
            const topicID = this.getTopicIDFromHash(location.hash);
            if (topicID) {
                this.openTopic(topicID);
            }
        };
    }
    init() {
        this.checkTopic();
    }
    listenToHashChange() {
        window.addEventListener("hashchange", this.checkTopic, false);
    }
    static getDataFromTemplate(topicID) {
        const list = document.querySelectorAll('[data-id="' + topicID + '"]');
        let data = null;
        if (list.length > 0) {
            data = window['__data_' + topicID];
            if (!data) {
                data = {};
            }
            data.id = topicID;
            const mapping = {
                url: 'url',
                datePublished: 'published',
                thumbnailUrl: 'image_url',
                headline: 'title',
            };
            const itemProps = DomUtils.scrapeItemProps(list[0]);
            for (let name in itemProps) {
                data[mapping[name]] = itemProps[name];
            }
        }
        return data;
    }
    openTopic(topicID) {
        if (topicID) {
            const modelRawData = TopicManager.getDataFromTemplate(topicID);
            let model = null;
            if (modelRawData) {
                model = new MediaModel(modelRawData);
            }
            topicID = topicID.split('/')[0];
            if (this._currentTopicID !== topicID) {
                this._currentTopicID = topicID;
                if (!model) {
                    logger.error('Cant open');
                }
                else {
                    this.openTopicAsLink(model);
                }
            }
        }
    }
    openTopicAsLink(model) {
        window.open(model ? model.url : '', '_self');
    }
    getTopicIDFromURL() {
        const regex = /^\/video\/[\w-]+~(\w+)\//g;
        const groups = regex.exec(document.location.pathname);
        return groups ? groups[1] : '';
    }
    getTopicIDFromHash(hash) {
        if (hash.indexOf("#topic/") > -1) {
            return hash.split('/')[1];
        }
        else {
            return '';
        }
    }
}
